import { actionCreatorFactory } from "typescript-fsa";
import { mandantendetails, userdetails } from "../typing/types";


const actionCreator = actionCreatorFactory("USERDETAILBOX");

 const resetData = actionCreator<{data:userdetails}>("UDB_RESETDATA");
 const resetincmandData = actionCreator<{data:mandantendetails[]}>("UDB_RESETindmandDATA");
 const resetnotmandData = actionCreator<{data:mandantendetails[]}>("UDB_RESETnotmandDATA");
 const SetUserDetail = actionCreator<{data:any, type:string}>("UDB_SETSTARTTIME");
 const CopyUserToNew = actionCreator<{data:any}>("UDB_SETSINFO");
 
 export const UserDetailsActions = { resetData, SetUserDetail, CopyUserToNew, resetincmandData, resetnotmandData}


